import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/views/components/GenerateModalStep.module.scss';

export default function GenerateModalStep({
  handleStepClick,
  activeStep,
  step,
  number,
  label,
}) {
  return (
    <div
      onClick={handleStepClick(step)}
      className={[
        styles.step,
        activeStep === step ? styles.active : '',
        activeStep > step ? styles.completed : '',
      ].join(' ')}
    >
      <div className={styles.number}>
        { activeStep > step ? <div className={styles.tick} /> : number }
      </div>
      <div className={styles.text}>{label}</div>
    </div>
  );
}


GenerateModalStep.propTypes = {
  handleStepClick: PropTypes.func.isRequired,
  activeStep: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  number: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
};
